
export async function instantiate(imports={}, runInitializer=true) {
    const cachedJsObjects = new WeakMap();
    // ref must be non-null
    function getCachedJsObject(ref, ifNotCached) {
        if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
        const cached = cachedJsObjects.get(ref);
        if (cached !== void 0) return cached;
        cachedJsObjects.set(ref, ifNotCached);
        return ifNotCached;
    }

    const _ref_Li9za2lrby5tanM_ = imports['./skiko.mjs'];
    const _ref_Li9za2lrby5tanM_c2tpa29BcGk = imports['./skiko.mjs'].skikoApi;
    const _ref_QGpzLWpvZGEvY29yZQ_ = imports['@js-joda/core'];

    const wasmJsTag = WebAssembly.JSTag;
    const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

    const js_code = {
        'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
        'kotlin.wasm.internal.jsThrow' : typeof wasmJsTag === 'undefined' || wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
        'kotlin.wasm.internal.stringLength' : (x) => x.length,
        'kotlin.wasm.internal.jsExportStringToWasm' : (src, srcOffset, srcLength, dstAddr) => { 
            const mem16 = new Uint16Array(wasmExports.memory.buffer, dstAddr, srcLength);
            let arrayIndex = 0;
            let srcIndex = srcOffset;
            while (arrayIndex < srcLength) {
                mem16.set([src.charCodeAt(srcIndex)], arrayIndex);
                srcIndex++;
                arrayIndex++;
            }     
             },
        'kotlin.wasm.internal.importStringFromWasm' : (address, length, prefix) => { 
            const mem16 = new Uint16Array(wasmExports.memory.buffer, address, length);
            const str = String.fromCharCode.apply(null, mem16);
            return (prefix == null) ? str : prefix + str;
             },
        'kotlin.wasm.internal.getJsEmptyString' : () => '',
        'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
        'kotlin.wasm.internal.getJsTrue' : () => true,
        'kotlin.wasm.internal.getJsFalse' : () => false,
        'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
        'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
        'kotlin.wasm.internal.externrefHashCode' : 
        (() => {
        const dataView = new DataView(new ArrayBuffer(8));
        function numberHashCode(obj) {
            if ((obj | 0) === obj) {
                return obj | 0;
            } else {
                dataView.setFloat64(0, obj, true);
                return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
            }
        }
        
        const hashCodes = new WeakMap();
        function getObjectHashCode(obj) {
            const res = hashCodes.get(obj);
            if (res === undefined) {
                const POW_2_32 = 4294967296;
                const hash = (Math.random() * POW_2_32) | 0;
                hashCodes.set(obj, hash);
                return hash;
            }
            return res;
        }
        
        function getStringHashCode(str) {
            var hash = 0;
            for (var i = 0; i < str.length; i++) {
                var code  = str.charCodeAt(i);
                hash  = (hash * 31 + code) | 0;
            }
            return hash;
        }
        
        return (obj) => {
            if (obj == null) {
                return 0;
            }
            switch (typeof obj) {
                case "object":
                case "function":
                    return getObjectHashCode(obj);
                case "number":
                    return numberHashCode(obj);
                case "boolean":
                    return obj ? 1231 : 1237;
                default:
                    return getStringHashCode(String(obj)); 
            }
        }
        })(),
        'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
        'kotlin.wasm.internal.newJsArray' : () => [],
        'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
        'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
        'kotlin.js.jsCatch' : (f) => { 
            let result = null;
            try { 
                f();
            } catch (e) {
               result = e;
            }
            return result;
             },
        'kotlin.js.__convertKotlinClosureToJsClosure_(()->Unit)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Unit)'](f, )),
        'kotlin.js.jsThrow' : (e) => { throw e; },
        'kotlin.io.printlnImpl' : (message) => console.log(message),
        'kotlin.io.printError' : (error) => console.error(error),
        'kotlin.js.jsArrayGet' : (array, index) => array[index],
        'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
        'kotlin.js.JsArray_$external_fun' : () => new Array(),
        'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
        'kotlin.js.stackPlaceHolder_js_code' : () => (''),
        'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
        'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
        'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
        'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
        'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
        'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
        'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
        'kotlin.js.JsString_$external_class_get' : () => JsString,
        'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
        'kotlin.js.__convertKotlinClosureToJsClosure_((Js?)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Js?)'](f, p0)),
        'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
        'kotlin.js.__convertKotlinClosureToJsClosure_((Js)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Js?)'](f, p0)),
        'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
        'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
        'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
        'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
        'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
        'kotlin.time.Date_$external_fun' : () => new Date(),
        'kotlin.time.getTime_$external_fun' : (_this, ) => _this.getTime(),
        'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
        'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
        'kotlin.time.dateNow' : () => Date.now(),
        'kotlin.uuid.cryptoGetRandomValues' : (size) => crypto.getRandomValues(new Int8Array(size)),
        'kotlin.uuid.get' : (array, index) => array[index],
        'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
        'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
        'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
        'kotlinx.coroutines.error_$external_fun' : (_this, p0) => _this.error(p0),
        'kotlinx.coroutines.console_$external_prop_getter' : () => console,
        'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
        'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
        'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
        'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
            const handler = (event) => {
                if (event.source == window && event.data == 'dispatchCoroutine') {
                    event.stopPropagation();
                    process();
                }
            }
            window.addEventListener('message', handler, true);
        },
        'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
        'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
        'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
        'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
        'org.khronos.webgl.getMethodImplForInt8Array' : (obj, index) => obj[index],
        'org.khronos.webgl.setMethodImplForInt8Array' : (obj, index, value) => { obj[index] = value; },
        'org.khronos.webgl.Int8Array_$external_fun' : (p0) => new Int8Array(p0),
        'org.khronos.webgl.Int8Array_$external_fun_1' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
        'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
        'org.khronos.webgl.slice_$external_fun' : (_this, p0, p1, isDefault0) => _this.slice(p0, isDefault0 ? undefined : p1, ),
        'org.khronos.webgl.buffer_$external_prop_getter' : (_this) => _this.buffer,
        'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
        'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
        'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
        'org.w3c.dom.css.objectFit_$external_prop_setter' : (_this, v) => _this.objectFit = v,
        'org.w3c.dom.css.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
        'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
        'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
        'org.w3c.dom.css.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
        'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
        'org.w3c.dom.css.zIndex_$external_prop_setter' : (_this, v) => _this.zIndex = v,
        'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
        'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
        'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
        'org.w3c.dom.events.target_$external_prop_getter' : (_this) => _this.target,
        'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
        'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
        'org.w3c.dom.events.Event_$external_class_get' : () => Event,
        'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
        'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
        'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
        'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
        'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
        'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
        'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
        'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
        'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
        'org.w3c.dom.events.__convertKotlinClosureToJsClosure_((Js)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Unit)'](f, p0)),
        'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
        'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
        'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
        'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
        'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
        'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
        'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
        'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
        'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
        'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
        'org.w3c.dom.events.MouseEvent_$external_class_instanceof' : (x) => x instanceof MouseEvent,
        'org.w3c.dom.events.MouseEvent_$external_class_get' : () => MouseEvent,
        'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
        'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
        'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
        'org.w3c.dom.events.WheelEvent_$external_class_get' : () => WheelEvent,
        'org.w3c.dom.ShadowRootInit' : (mode) => ({ mode: mode }),
        'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
        'org.w3c.dom.mediaDevices_$external_prop_getter' : (_this) => _this.mediaDevices,
        'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
        'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
        'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
        'org.w3c.dom.__convertKotlinClosureToJsClosure_((Double)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Double)->Unit)'](f, p0)),
        'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
        'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
        'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
        'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
        'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
        'org.w3c.dom.innerText_$external_prop_setter' : (_this, v) => _this.innerText = v,
        'org.w3c.dom.click_$external_fun' : (_this, ) => _this.click(),
        'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
        'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
        'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
        'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
        'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
        'org.w3c.dom.onLine_$external_prop_getter' : (_this) => _this.onLine,
        'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
        'org.w3c.dom.documentElement_$external_prop_getter' : (_this) => _this.documentElement,
        'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
        'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
        'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
        'org.w3c.dom.namespaceURI_$external_prop_getter' : (_this) => _this.namespaceURI,
        'org.w3c.dom.localName_$external_prop_getter' : (_this) => _this.localName,
        'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
        'org.w3c.dom.shadowRoot_$external_prop_getter' : (_this) => _this.shadowRoot,
        'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
        'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
        'org.w3c.dom.getAttribute_$external_fun' : (_this, p0) => _this.getAttribute(p0),
        'org.w3c.dom.getAttributeNS_$external_fun' : (_this, p0, p1) => _this.getAttributeNS(p0, p1),
        'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
        'org.w3c.dom.attachShadow_$external_fun' : (_this, p0) => _this.attachShadow(p0),
        'org.w3c.dom.insertAdjacentElement_$external_fun' : (_this, p0, p1) => _this.insertAdjacentElement(p0, p1),
        'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
        'org.w3c.dom.Element_$external_class_instanceof' : (x) => x instanceof Element,
        'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
        'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
        'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
        'org.w3c.dom.nodeName_$external_prop_getter' : (_this) => _this.nodeName,
        'org.w3c.dom.isConnected_$external_prop_getter' : (_this) => _this.isConnected,
        'org.w3c.dom.childNodes_$external_prop_getter' : (_this) => _this.childNodes,
        'org.w3c.dom.lookupPrefix_$external_fun' : (_this, p0) => _this.lookupPrefix(p0),
        'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
        'org.w3c.dom.querySelector_$external_fun' : (_this, p0) => _this.querySelector(p0),
        'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
        'org.w3c.dom.identifier_$external_prop_getter' : (_this) => _this.identifier,
        'org.w3c.dom.clientX_$external_prop_getter' : (_this) => _this.clientX,
        'org.w3c.dom.clientY_$external_prop_getter' : (_this) => _this.clientY,
        'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
        'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
        'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
        'org.w3c.dom.Companion_$external_object_getInstance' : () => ({}),
        'org.w3c.dom.videoWidth_$external_prop_getter' : (_this) => _this.videoWidth,
        'org.w3c.dom.videoHeight_$external_prop_getter' : (_this) => _this.videoHeight,
        'org.w3c.dom.playsInline_$external_prop_setter' : (_this, v) => _this.playsInline = v,
        'org.w3c.dom.HTMLVideoElement_$external_class_instanceof' : (x) => x instanceof HTMLVideoElement,
        'org.w3c.dom.HTMLVideoElement_$external_class_get' : () => HTMLVideoElement,
        'org.w3c.dom.width_$external_prop_getter' : (_this) => _this.width,
        'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
        'org.w3c.dom.height_$external_prop_getter' : (_this) => _this.height,
        'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
        'org.w3c.dom.getContext_$external_fun' : (_this, p0, p1) => _this.getContext(p0, ...p1),
        'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
        'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
        'org.w3c.dom.CanvasRenderingContext2D_$external_class_instanceof' : (x) => x instanceof CanvasRenderingContext2D,
        'org.w3c.dom.CanvasRenderingContext2D_$external_class_get' : () => CanvasRenderingContext2D,
        'org.w3c.dom.width_$external_prop_getter_1' : (_this) => _this.width,
        'org.w3c.dom.height_$external_prop_getter_1' : (_this) => _this.height,
        'org.w3c.dom.data_$external_prop_getter' : (_this) => _this.data,
        'org.w3c.dom.HTMLDivElement_$external_class_instanceof' : (x) => x instanceof HTMLDivElement,
        'org.w3c.dom.HTMLDivElement_$external_class_get' : () => HTMLDivElement,
        'org.w3c.dom.targetTouches_$external_prop_getter' : (_this) => _this.targetTouches,
        'org.w3c.dom.changedTouches_$external_prop_getter' : (_this) => _this.changedTouches,
        'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
        'org.w3c.dom.TouchEvent_$external_class_get' : () => TouchEvent,
        'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
        'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
        'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
        'org.w3c.dom.srcObject_$external_prop_setter' : (_this, v) => _this.srcObject = v,
        'org.w3c.dom.autoplay_$external_prop_setter' : (_this, v) => _this.autoplay = v,
        'org.w3c.dom.muted_$external_prop_setter' : (_this, v) => _this.muted = v,
        'org.w3c.dom.drawImage_$external_fun' : (_this, p0, p1, p2) => _this.drawImage(p0, p1, p2),
        'org.w3c.dom.getImageData_$external_fun' : (_this, p0, p1, p2, p3) => _this.getImageData(p0, p1, p2, p3),
        'org.w3c.dom.mediacapture.MediaStreamConstraints_js_code' : (video, audio) => ({ video: video, audio: audio }),
        'org.w3c.dom.mediacapture.getUserMedia_$external_fun' : (_this, p0, isDefault0) => _this.getUserMedia(isDefault0 ? undefined : p0, ),
        'org.w3c.dom.mediacapture.getTracks_$external_fun' : (_this, ) => _this.getTracks(),
        'org.w3c.dom.mediacapture.MediaStream_$external_class_instanceof' : (x) => x instanceof MediaStream,
        'org.w3c.dom.mediacapture.MediaStream_$external_class_get' : () => MediaStream,
        'org.w3c.dom.mediacapture.stop_$external_fun' : (_this, ) => _this.stop(),
        'org.w3c.dom.parsing.DOMParser_$external_fun' : () => new DOMParser(),
        'org.w3c.dom.parsing.parseFromString_$external_fun' : (_this, p0, p1) => _this.parseFromString(p0, p1),
        'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
        'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
        'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
        'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
        'org.w3c.xhr.XMLHttpRequest_$external_fun' : () => new XMLHttpRequest(),
        'org.w3c.xhr.status_$external_prop_getter' : (_this) => _this.status,
        'org.w3c.xhr.open_$external_fun' : (_this, p0, p1, p2, p3, p4, isDefault0, isDefault1) => _this.open(p0, p1, p2, isDefault0 ? undefined : p3, isDefault1 ? undefined : p4, ),
        'org.w3c.xhr.send_$external_fun' : (_this, ) => _this.send(),
        'org.w3c.xhr.overrideMimeType_$external_fun' : (_this, p0) => _this.overrideMimeType(p0),
        'kotlinx.browser.window_$external_prop_getter' : () => window,
        'kotlinx.browser.document_$external_prop_getter' : () => document,
        'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
        'org.w3c.dom.item_$external_fun_1' : (_this, p0) => _this.item(p0),
        'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
        'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
        'org.jetbrains.skiko.w3c.language_$external_prop_getter' : (_this) => _this.language,
        'org.jetbrains.skiko.w3c.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
        'org.jetbrains.skiko.w3c.navigator_$external_prop_getter' : (_this) => _this.navigator,
        'org.jetbrains.skiko.w3c.performance_$external_prop_getter' : (_this) => _this.performance,
        'org.jetbrains.skiko.w3c.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
        'org.jetbrains.skiko.w3c.window_$external_object_getInstance' : () => window,
        'org.jetbrains.skiko.w3c.now_$external_fun' : (_this, ) => _this.now(),
        'org.jetbrains.skiko.w3c.width_$external_prop_getter' : (_this) => _this.width,
        'org.jetbrains.skiko.w3c.height_$external_prop_getter' : (_this) => _this.height,
        'org.jetbrains.skiko.w3c.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
        'org.jetbrains.skiko.w3c.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
        'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
        'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
        'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
        'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
        'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
        'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
        'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
            return {
                alpha: 1,
                depth: 1,
                stencil: 8,
                antialias: 0,
                premultipliedAlpha: 1,
                preserveDrawingBuffer: 0,
                preferLowPowerToHighPerformance: 0,
                failIfMajorPerformanceCaveat: 0,
                enableExtensionsByDefault: 1,
                explicitSwapControl: 0,
                renderViaOffscreenBackBuffer: 0,
                majorVersion: 2,
            }
        }
        ,
        'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
        'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
        'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
        'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
        'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
        'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
        'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
        'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
        'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
        'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
        'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
        'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
        'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
                window.navigator.clipboard && 
                window.navigator.clipboard.write && 
                window.navigator.clipboard.read && 
                typeof(ClipboardItem) !== 'undefined'
                )
            ,
        'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
        'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
        'androidx.compose.ui.platform.accessibility.removeAllChildrenOf' : (element) => { element.replaceChildren() },
        'androidx.compose.ui.platform.accessibility.setA11YAriaRole' : (element, ariaRoleId) => { 
                var roleValue = "";
                switch (ariaRoleId) {
                    case 0: // Role.Button
                        roleValue = "button";
                        break;
                    case 1: // Role.Checkbox
                        roleValue = "checkbox";
                        break;
                    case 2: // Role.Switch
                        roleValue = "switch";
                        break;
                    case 3: // Role.RadioButton
                        roleValue = "radio";
                        break;
                    case 4: // Role.Tab
                        roleValue = "tab";
                        break;
                    case 5: // Role.Image
                        roleValue = "img";
                        break;
                    case 6: // Role.DropdownList
                        roleValue = "menu";
                        break;
                    case 7: // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
                        roleValue = "heading";
                        break;
                    case 8: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
                        roleValue = "textbox";
                        break;
                    case 9: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
                        roleValue = "list";
                        break;
                    case 10: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
                        roleValue = "grid";
                        break;
                    default:
                        break;
                }
                if (roleValue.length > 0) { 
                    element.setAttribute("role", roleValue);
                } else {
                    element.removeAttribute("role");
                }
             },
        'androidx.compose.ui.platform.accessibility.setSizeAndPosition' : (element, left, top, width, height) => { 
               element.style.left = "" + left + "px";
               element.style.top = "" + top + "px";
               element.style.width = "" + width + "px";
               element.style.height = "" + height + "px";
             },
        'androidx.compose.ui.window.documentIsVisible' : () => document.visibilityState === 'visible',
        'androidx.compose.ui.window.force_$external_prop_getter' : (_this) => _this.force,
        'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
        'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
        'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
        'org.jetbrains.compose.resources.isInTestEnvironment' : () => window.composeResourcesTesting == true,
        'org.jetbrains.compose.resources.requestResponseAsByteArray' : (req) =>  {
                var text = req.responseText;
                var int8Arr = new Int8Array(text.length);
                for (var i = 0; i < text.length; i++) {
                    int8Arr[i] = text.charCodeAt(i) & 0xFF;
                }
                return int8Arr;
            },
        'org.jetbrains.compose.resources.jsExportInt8ArrayToWasm' :  (src, size, dstAddr) => {
                const mem8 = new Int8Array(wasmExports.memory.buffer, dstAddr, size);
                mem8.set(src);
            }
        ,
        'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
        'kotlinx.datetime.internal.Date_$external_fun' : (p0) => new Date(p0),
        'kotlinx.datetime.internal.getTimezoneOffset_$external_fun' : (_this, ) => _this.getTimezoneOffset(),
        'kotlinx.datetime.internal.JSJoda.ZoneRulesProvider_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneRulesProvider,
        'kotlinx.datetime.internal.JSJoda.id_$external_fun' : (_this, ) => _this.id(),
        'kotlinx.datetime.internal.JSJoda.systemDefault_$external_fun' : (_this, ) => _this.systemDefault(),
        'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneId,
        'kotlinx.datetime.internal.withCaughtJsException' : (body) => {
            try {
                body();
                return null;
            } catch(e) {
                return e;
            }
        },
        'kotlinx.datetime.internal.getExceptionMessage' : (jsException) => jsException.message,
        'kotlinx.datetime.internal.getZones' : (rulesProvider) => rulesProvider.getTzdbData().zones,
        'kotlinx.datetime.internal.getLinks' : (rulesProvider) => rulesProvider.getTzdbData().links,
        'androidx.navigation.refBrowserWindow' : () => window,
        'androidx.navigation.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.navigation.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.navigation.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'androidx.navigation.location_$external_prop_getter' : (_this) => _this.location,
        'androidx.navigation.history_$external_prop_getter' : (_this) => _this.history,
        'androidx.navigation.console_$external_prop_getter' : (_this) => _this.console,
        'androidx.navigation.origin_$external_prop_getter' : (_this) => _this.origin,
        'androidx.navigation.pathname_$external_prop_getter' : (_this) => _this.pathname,
        'androidx.navigation.hash_$external_prop_getter' : (_this) => _this.hash,
        'androidx.navigation.state_$external_prop_getter' : (_this) => _this.state,
        'androidx.navigation.decodeURIComponent_$external_fun' : (p0) => decodeURIComponent(p0),
        'androidx.navigation.state_$external_prop_getter_1' : (_this) => _this.state,
        'androidx.navigation.pushState_$external_fun' : (_this, p0, p1, p2) => _this.pushState(p0, p1, p2),
        'androidx.navigation.replaceState_$external_fun' : (_this, p0, p1, p2) => _this.replaceState(p0, p1, p2),
        'androidx.navigation.addEventListener_$external_fun' : (_this, p0, p1) => _this.addEventListener(p0, p1),
        'androidx.navigation.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
        'androidx.navigation.warn_$external_fun' : (_this, p0) => _this.warn(p0),
        'androidx.navigation.encodeURIComponent_$external_fun' : (p0) => encodeURIComponent(p0),
        'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'com.salvitat.mykee.presentation.common.filesystem.showSaveFilePicker' : (defaultFileName, mimeType, extension) => 
        {
            const accept = (mimeType && extension) 
              ? { [mimeType]: [extension] }
              : undefined
            return window.showSaveFilePicker({
                suggestedName: defaultFileName,
                types: [{
                    description: 'Files',
                    accept,
                }]
            })
        }
        ,
        'com.salvitat.mykee.presentation.common.filesystem.createWritable_$external_fun' : (_this, ) => _this.createWritable(),
        'com.salvitat.mykee.presentation.common.filesystem.write_$external_fun' : (_this, p0) => _this.write(p0),
        'com.salvitat.mykee.presentation.common.filesystem.close_$external_fun' : (_this, ) => _this.close(),
        'com.salvitat.mykee.presentation.common.permissions.permissionDescriptor_js_code' : (name, userVisibleOnly, sysex) => 
            {
                const descriptor = {name: name};
                if (userVisibleOnly != null) descriptor.userVisibleOnly = userVisibleOnly;
                if (sysex != null) descriptor.sysex = sysex;
                return descriptor;
            }
        ,
        'com.salvitat.mykee.presentation.common.permissions.getPermissionsApi' : () => navigator.permissions,
        'com.salvitat.mykee.presentation.common.permissions.external.state_$external_prop_getter' : (_this) => _this.state,
        'com.salvitat.mykee.presentation.common.permissions.external.query_$external_fun' : (_this, p0) => _this.query(p0),
        'com.salvitat.mykee.presentation.common.qrcode.getVideoConstraints' : () => ({facingMode:{ideal:"environment"}}),
        'com.salvitat.mykee.presentation.common.qrcode.external.data_$external_prop_getter' : (_this) => _this.data,
        'com.salvitat.mykee.presentation.common.qrcode.external.location_$external_prop_getter' : (_this) => _this.location,
        'com.salvitat.mykee.presentation.common.qrcode.external.jsQR_$external_fun' : (p0, p1, p2) => jsQR(p0, p1, p2),
        'com.salvitat.mykee.presentation.common.qrcode.external.topLeftCorner_$external_prop_getter' : (_this) => _this.topLeftCorner,
        'com.salvitat.mykee.presentation.common.qrcode.external.topRightCorner_$external_prop_getter' : (_this) => _this.topRightCorner,
        'com.salvitat.mykee.presentation.common.qrcode.external.bottomLeftCorner_$external_prop_getter' : (_this) => _this.bottomLeftCorner,
        'com.salvitat.mykee.presentation.common.qrcode.external.bottomRightCorner_$external_prop_getter' : (_this) => _this.bottomRightCorner,
        'com.salvitat.mykee.presentation.common.qrcode.external.x_$external_prop_getter' : (_this) => _this.x,
        'com.salvitat.mykee.presentation.common.qrcode.external.y_$external_prop_getter' : (_this) => _this.y,
        'nl.smartangle.kmp.bluetooth.getBluetooth' : () => window.navigator.bluetooth,
        'nl.smartangle.kmp.bluetooth.extensions.createAcceptAllDevices' : (optionalServices) => 
        {
            return {
                acceptAllDevices: true,
                optionalServices: optionalServices.length > 0 ? optionalServices : undefined
            }
        }
        ,
        'nl.smartangle.kmp.bluetooth.extensions.createFilterDevices' : (filters, optionalServices) => 
        {
            return {
                acceptAllDevices: false,
                filters: filters,
                optionalServices: optionalServices.length > 0 ? optionalServices : undefined
            }
        }
        ,
        'nl.smartangle.kmp.bluetooth.extensions.createFilter' : (namePrefix, name) => 
            {
                return {
                    namePrefix: namePrefix ?? undefined,
                    name: name ?? undefined
                }
            }
        ,
        'nl.smartangle.kmp.bluetooth.external.requestDevice_$external_fun' : (_this, p0, isDefault0) => _this.requestDevice(isDefault0 ? undefined : p0, ),
        'nl.smartangle.kmp.bluetooth.external.indicate_$external_prop_getter' : (_this) => _this.indicate,
        'nl.smartangle.kmp.bluetooth.external.notify_$external_prop_getter' : (_this) => _this.notify,
        'nl.smartangle.kmp.bluetooth.external.write_$external_prop_getter' : (_this) => _this.write,
        'nl.smartangle.kmp.bluetooth.external.writeWithoutResponse_$external_prop_getter' : (_this) => _this.writeWithoutResponse,
        'nl.smartangle.kmp.bluetooth.external.id_$external_prop_getter' : (_this) => _this.id,
        'nl.smartangle.kmp.bluetooth.external.name_$external_prop_getter' : (_this) => _this.name,
        'nl.smartangle.kmp.bluetooth.external.gatt_$external_prop_getter' : (_this) => _this.gatt,
        'nl.smartangle.kmp.bluetooth.external.uuid_$external_prop_getter' : (_this) => _this.uuid,
        'nl.smartangle.kmp.bluetooth.external.properties_$external_prop_getter' : (_this) => _this.properties,
        'nl.smartangle.kmp.bluetooth.external.value_$external_prop_getter' : (_this) => _this.value,
        'nl.smartangle.kmp.bluetooth.external.readValue_$external_fun' : (_this, ) => _this.readValue(),
        'nl.smartangle.kmp.bluetooth.external.writeValueWithResponse_$external_fun' : (_this, p0) => _this.writeValueWithResponse(p0),
        'nl.smartangle.kmp.bluetooth.external.writeValueWithoutResponse_$external_fun' : (_this, p0) => _this.writeValueWithoutResponse(p0),
        'nl.smartangle.kmp.bluetooth.external.startNotifications_$external_fun' : (_this, ) => _this.startNotifications(),
        'nl.smartangle.kmp.bluetooth.external.BluetoothRemoteGATTCharacteristic_$external_class_instanceof' : (x) => x instanceof BluetoothRemoteGATTCharacteristic,
        'nl.smartangle.kmp.bluetooth.external.BluetoothRemoteGATTCharacteristic_$external_class_get' : () => BluetoothRemoteGATTCharacteristic,
        'nl.smartangle.kmp.bluetooth.external.device_$external_prop_getter' : (_this) => _this.device,
        'nl.smartangle.kmp.bluetooth.external.connected_$external_prop_getter' : (_this) => _this.connected,
        'nl.smartangle.kmp.bluetooth.external.connect_$external_fun' : (_this, ) => _this.connect(),
        'nl.smartangle.kmp.bluetooth.external.disconnect_$external_fun' : (_this, ) => _this.disconnect(),
        'nl.smartangle.kmp.bluetooth.external.getPrimaryService_$external_fun' : (_this, p0) => _this.getPrimaryService(p0),
        'nl.smartangle.kmp.bluetooth.external.uuid_$external_prop_getter_1' : (_this) => _this.uuid,
        'nl.smartangle.kmp.bluetooth.external.getCharacteristic_$external_fun' : (_this, p0) => _this.getCharacteristic(p0),
        'co.touchlab.kermit.consoleError' : (output) => console.error(output),
        'co.touchlab.kermit.consoleWarn' : (output) => console.warn(output),
        'co.touchlab.kermit.consoleInfo' : (output) => console.info(output),
        'co.touchlab.kermit.consoleLog' : (output) => console.log(output),
        'nl.smartangle.kmp.indexeddb.createObjectStoreOptions' : (keyPath, autoIncrement) => ({ keyPath: keyPath, autoIncrement: autoIncrement }),
        'nl.smartangle.kmp.indexeddb.createObjectStoreOptions_1' : (autoIncrement) => ({ autoIncrement: autoIncrement }),
        'nl.smartangle.kmp.indexeddb.toJs' : (durability) => ({ durability: durability }),
        'nl.smartangle.kmp.indexeddb.getIndexedDB' : () => window.indexedDB,
        'nl.smartangle.kmp.indexeddb.parse' : (jsonStr) => JSON.parse(jsonStr),
        'nl.smartangle.kmp.indexeddb.stringify' : (obj) => JSON.stringify(obj),
        'nl.smartangle.kmp.indexeddb.external.continue_$external_fun' : (_this, p0, isDefault0) => _this.continue(isDefault0 ? undefined : p0, ),
        'nl.smartangle.kmp.indexeddb.external.value_$external_prop_getter' : (_this) => _this.value,
        'nl.smartangle.kmp.indexeddb.external.createObjectStore_$external_fun' : (_this, p0, p1, isDefault0) => _this.createObjectStore(p0, isDefault0 ? undefined : p1, ),
        'nl.smartangle.kmp.indexeddb.external.transaction_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1) => _this.transaction(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
        'nl.smartangle.kmp.indexeddb.external.IDBDatabase_$external_class_instanceof' : (x) => x instanceof IDBDatabase,
        'nl.smartangle.kmp.indexeddb.external.IDBDatabase_$external_class_get' : () => IDBDatabase,
        'nl.smartangle.kmp.indexeddb.external.open_$external_fun' : (_this, p0, p1, isDefault0) => _this.open(p0, isDefault0 ? undefined : p1, ),
        'nl.smartangle.kmp.indexeddb.external.get_$external_fun' : (_this, p0, isDefault0) => _this.get(isDefault0 ? undefined : p0, ),
        'nl.smartangle.kmp.indexeddb.external.getAll_$external_fun' : (_this, p0, p1, isDefault0, isDefault1) => _this.getAll(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
        'nl.smartangle.kmp.indexeddb.external.transaction_$external_prop_getter' : (_this) => _this.transaction,
        'nl.smartangle.kmp.indexeddb.external.createIndex_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.createIndex(p0, p1, isDefault0 ? undefined : p2, ),
        'nl.smartangle.kmp.indexeddb.external.createIndex_$external_fun_1' : (_this, p0, p1, p2, isDefault0) => _this.createIndex(p0, p1, isDefault0 ? undefined : p2, ),
        'nl.smartangle.kmp.indexeddb.external.delete_$external_fun' : (_this, p0) => _this.delete(p0),
        'nl.smartangle.kmp.indexeddb.external.get_$external_fun_1' : (_this, p0) => _this.get(p0),
        'nl.smartangle.kmp.indexeddb.external.getAll_$external_fun_1' : (_this, p0, isDefault0) => _this.getAll(isDefault0 ? undefined : p0, ),
        'nl.smartangle.kmp.indexeddb.external.index_$external_fun' : (_this, p0) => _this.index(p0),
        'nl.smartangle.kmp.indexeddb.external.openCursor_$external_fun' : (_this, p0, p1, isDefault0, isDefault1) => _this.openCursor(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
        'nl.smartangle.kmp.indexeddb.external.put_$external_fun' : (_this, p0, p1, isDefault0) => _this.put(p0, isDefault0 ? undefined : p1, ),
        'nl.smartangle.kmp.indexeddb.external.onupgradeneeded_$external_prop_setter' : (_this, v) => _this.onupgradeneeded = v,
        'nl.smartangle.kmp.indexeddb.external.onblocked_$external_prop_setter' : (_this, v) => _this.onblocked = v,
        'nl.smartangle.kmp.indexeddb.external.error_$external_prop_getter' : (_this) => _this.error,
        'nl.smartangle.kmp.indexeddb.external.result_$external_prop_getter' : (_this) => _this.result,
        'nl.smartangle.kmp.indexeddb.external.transaction_$external_prop_getter_1' : (_this) => _this.transaction,
        'nl.smartangle.kmp.indexeddb.external.onsuccess_$external_prop_setter' : (_this, v) => _this.onsuccess = v,
        'nl.smartangle.kmp.indexeddb.external.onerror_$external_prop_setter' : (_this, v) => _this.onerror = v,
        'nl.smartangle.kmp.indexeddb.external.error_$external_prop_getter_1' : (_this) => _this.error,
        'nl.smartangle.kmp.indexeddb.external.objectStore_$external_fun' : (_this, p0) => _this.objectStore(p0),
        'nl.smartangle.kmp.indexeddb.external.onabort_$external_prop_setter' : (_this, v) => _this.onabort = v,
        'nl.smartangle.kmp.indexeddb.external.oncomplete_$external_prop_setter' : (_this, v) => _this.oncomplete = v,
        'nl.smartangle.kmp.indexeddb.external.onerror_$external_prop_setter_1' : (_this, v) => _this.onerror = v,
        'nl.smartangle.kmp.indexeddb.external.oldVersion_$external_prop_getter' : (_this) => _this.oldVersion,
        'nl.smartangle.kmp.indexeddb.external.newVersion_$external_prop_getter' : (_this) => _this.newVersion,
        'nl.smartangle.kmp.indexeddb.external.target_$external_prop_getter' : (_this) => _this.target,
        'nl.smartangle.kmp.indexeddb.external.IDBVersionChangeEvent_$external_class_instanceof' : (x) => x instanceof IDBVersionChangeEvent,
        'nl.smartangle.kmp.indexeddb.external.IDBVersionChangeEvent_$external_class_get' : () => IDBVersionChangeEvent
    }
    
    // Placed here to give access to it from externals (js_code)
    let wasmInstance;
    let require; 
    let wasmExports;

    const isNodeJs = (typeof process !== 'undefined') && (process.release.name === 'node');
    const isDeno = !isNodeJs && (typeof Deno !== 'undefined')
    const isStandaloneJsVM =
        !isDeno && !isNodeJs && (
            typeof d8 !== 'undefined' // V8
            || typeof inIon !== 'undefined' // SpiderMonkey
            || typeof jscOptions !== 'undefined' // JavaScriptCore
        );
    const isBrowser = !isNodeJs && !isDeno && !isStandaloneJsVM && (typeof window !== 'undefined' || typeof self !== 'undefined');
    
    if (!isNodeJs && !isDeno && !isStandaloneJsVM && !isBrowser) {
      throw "Supported JS engine not detected";
    }

    const wasmFilePath = './MykeeCompanionApp-apps-tapcheck.wasm';

    const importObject = {
        js_code,
        intrinsics: {
            tag: wasmTag
        },
        './skiko.mjs': imports['./skiko.mjs'],

    };
    
    try {
      if (isNodeJs) {
        const module = await import(/* webpackIgnore: true */'node:module');
        const importMeta = import.meta;
        require = module.default.createRequire(importMeta.url);
        const fs = require('fs');
        const url = require('url');
        const filepath = import.meta.resolve(wasmFilePath);
        const wasmBuffer = fs.readFileSync(url.fileURLToPath(filepath));
        const wasmModule = new WebAssembly.Module(wasmBuffer);
        wasmInstance = new WebAssembly.Instance(wasmModule, importObject);
      }
      
      if (isDeno) {
        const path = await import(/* webpackIgnore: true */'https://deno.land/std/path/mod.ts');
        const binary = Deno.readFileSync(path.fromFileUrl(import.meta.resolve(wasmFilePath)));
        const module = await WebAssembly.compile(binary);
        wasmInstance = await WebAssembly.instantiate(module, importObject);
      }
      
      if (isStandaloneJsVM) {
        const wasmBuffer = read(wasmFilePath, 'binary');
        const wasmModule = new WebAssembly.Module(wasmBuffer);
        wasmInstance = new WebAssembly.Instance(wasmModule, importObject);
      }
      
      if (isBrowser) {
        wasmInstance = (await WebAssembly.instantiateStreaming(fetch(new URL('./MykeeCompanionApp-apps-tapcheck.wasm',import.meta.url).href), importObject)).instance;
      }
    } catch (e) {
      if (e instanceof WebAssembly.CompileError) {
        let text = `Please make sure that your runtime environment supports the latest version of Wasm GC and Exception-Handling proposals.
For more information, see https://kotl.in/wasm-help
`;
        if (isBrowser) {
          console.error(text);
        } else {
          const t = "\n" + text;
          if (typeof console !== "undefined" && console.log !== void 0) 
            console.log(t);
          else 
            print(t);
        }
      }
      throw e;
    }
    
    wasmExports = wasmInstance.exports;
    if (runInitializer) {
        wasmExports._initialize();
    }

    return { instance: wasmInstance,  exports: wasmExports };
}
